import { FF } from 'modules/feature-flags/featureFlags.generated';
import { useSplitFlag } from 'modules/feature-flags/useSplitFlag';
import { useMemo } from 'react';
import { CacheStrategy } from 'modules/viewer/PixelCacheStategy';

export const useViewerDownloadingFlags = (): {
  viewerCacheStrategy: CacheStrategy;
  loadingViewerDownloadingFlags: boolean;
} => {
  const [viewerCacheStrategy, loadingViewerCacheStrategy] = useSplitFlag<CacheStrategy>(
    FF.VIEWER_CACHE_STRATEGY
  );

  return useMemo(
    () => ({
      viewerCacheStrategy,
      loadingViewerDownloadingFlags: loadingViewerCacheStrategy,
    }),
    [viewerCacheStrategy, loadingViewerCacheStrategy]
  );
};
